import { render, staticRenderFns } from "./LgFinderPageModalidadeContrato.vue?vue&type=template&id=370012b8"
import script from "./LgFinderPageModalidadeContrato.vue?vue&type=script&lang=js"
export * from "./LgFinderPageModalidadeContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports